module.exports = __webpack_public_path__ + "img/illustrator-logo.5010820f.svg";